import { render, staticRenderFns } from "./FiltrosRelatorioBot.vue?vue&type=template&id=b24d9808&scoped=true"
import script from "./FiltrosRelatorioBot.vue?vue&type=script&lang=js"
export * from "./FiltrosRelatorioBot.vue?vue&type=script&lang=js"
import style0 from "./FiltrosRelatorioBot.vue?vue&type=style&index=0&id=b24d9808&prod&scoped=true&lang=css"
import style1 from "./FiltrosRelatorioBot.vue?vue&type=style&index=1&id=b24d9808&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24d9808",
  null
  
)

export default component.exports